import { render, staticRenderFns } from "./DigikalaIntegrator.vue?vue&type=template&id=4827df62&scoped=true&"
import script from "./DigikalaIntegrator.vue?vue&type=script&lang=js&"
export * from "./DigikalaIntegrator.vue?vue&type=script&lang=js&"
import style0 from "./DigikalaIntegrator.vue?vue&type=style&index=0&id=4827df62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4827df62",
  null
  
)

export default component.exports